import { render, staticRenderFns } from "./PartnerUser.vue?vue&type=template&id=674c9e50&scoped=true&"
import script from "./PartnerUser.vue?vue&type=script&lang=js&"
export * from "./PartnerUser.vue?vue&type=script&lang=js&"
import style0 from "./PartnerUser.vue?vue&type=style&index=0&id=674c9e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c9e50",
  null
  
)

export default component.exports